import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { faqData, WHATSAPP_LINK } from '../data/mock';
import { MessageCircle } from 'lucide-react';
import SEO from '../components/SEO';

const FAQ = () => {
  return (
    <div className="min-h-screen pt-16">
      <SEO 
        title="Perguntas Frequentes - W3Solar | Dúvidas sobre Energia Solar"
        description="Tire suas dúvidas sobre energia solar. Respostas sobre instalação, custos, manutenção, garantia e muito mais."
        keywords="dúvidas energia solar, faq painéis solares, perguntas energia solar, quanto tempo dura painel solar"
      />
      {/* Hero Section */}
      <section className="relative py-16 md:py-24 bg-gradient-to-br from-emerald-50 via-teal-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Perguntas Frequentes
            </h1>
            <p className="text-xl text-gray-600">
              Tire todas as suas dúvidas sobre energia solar
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Card className="border-2">
            <CardContent className="p-6 md:p-8">
              <Accordion type="single" collapsible className="w-full space-y-4">
                {faqData.map((faq) => (
                  <AccordionItem 
                    key={faq.id} 
                    value={`item-${faq.id}`}
                    className="border-2 border-gray-100 rounded-lg px-6 hover:border-emerald-300 transition-colors"
                  >
                    <AccordionTrigger className="text-left hover:no-underline py-5">
                      <span className="font-semibold text-gray-900 pr-4">
                        {faq.question}
                      </span>
                    </AccordionTrigger>
                    <AccordionContent className="text-gray-600 pb-5 leading-relaxed">
                      {faq.answer}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </CardContent>
          </Card>

          {/* Still have questions */}
          <div className="mt-12 text-center">
            <Card className="bg-gradient-to-br from-emerald-50 to-teal-50 border-2 border-emerald-200">
              <CardContent className="p-8">
                <MessageCircle className="h-12 w-12 text-emerald-600 mx-auto mb-4" />
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  Ainda tem dúvidas?
                </h3>
                <p className="text-gray-600 mb-6 max-w-xl mx-auto">
                  Nossa equipe está pronta para responder todas as suas perguntas e ajudar você a dar o primeiro passo rumo à energia solar.
                </p>
                <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer">
                  <Button size="lg" className="bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 text-white">
                    Falar com Especialista
                  </Button>
                </a>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Additional Info */}
      <section className="py-16 md:py-24 bg-gradient-to-br from-gray-50 to-emerald-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Informações Importantes
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <Card className="hover:shadow-lg transition-shadow">
              <CardContent className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  Garantias
                </h3>
                <ul className="space-y-2 text-gray-600">
                  <li>• 25 anos nos painéis solares</li>
                  <li>• 10 anos no inversor</li>
                  <li>• 5 anos na instalação</li>
                  <li>• 2 manutenções gratuitas no 1º ano</li>
                </ul>
              </CardContent>
            </Card>

            <Card className="hover:shadow-lg transition-shadow">
              <CardContent className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  Certificações
                </h3>
                <ul className="space-y-2 text-gray-600">
                  <li>• Equipamentos certificados pelo INMETRO</li>
                  <li>• Instaladores qualificados</li>
                  <li>• Normas ABNT seguidas</li>
                  <li>• Projeto aprovado pela concessionária</li>
                </ul>
              </CardContent>
            </Card>

            <Card className="hover:shadow-lg transition-shadow">
              <CardContent className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  Suporte
                </h3>
                <ul className="space-y-2 text-gray-600">
                  <li>• Atendimento personalizado</li>
                  <li>• Monitoramento remoto</li>
                  <li>• Suporte técnico disponível</li>
                  <li>• App para acompanhamento</li>
                </ul>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
